// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1brJt","alertIcon":"ConfirmModal_alertIcon__2Ca7c"};